export default __webpack_public_path__ + "static/media/marker.19d1566f.png";